import {env} from './EnvirementConfig';
class PrefixPath{
    static APP_NAME = 'AAM';
    static API_BASE_URL = env.API_ENDPOINT_URL
    static HUB_API_BASE_URL = env.HUB_API_ENDPOINT_URL;
    static App_URL = env.REACT_APP;
    static APP_PREFIX_PATH = '/app';
    static AUTH_PREFIX_PATH = '/auth';
    static PAYA_DEVELOPER_ID='9c4dc25d';
    static PAYA_HASH_KEY='4a5fc771697cac0374e8acdc';
    static PAYA_USER_ID='11ef49012f5d17b2b8f1671a';
    static PAYA_LOCATION_ID='11ef48613e7dfe8c892d1f0e';
    static PAYA_CC_PRODUCT_TRANSACTION_ID='11ef490259b6109e98430f98';
    static PAYA_ACH_PRODUCT_TRANSACTION_ID='11effdc4b9927ae4b6814d25';
}
export default PrefixPath;